import { Form } from "formik";
import { useSelector } from "react-redux";
import Select, { MultiValue } from "react-select";
import useFetch from "../../hooks/useFetch";
import { api } from "../../config/Api";
import { FormInterface, IndustryInterface, PositionForSelect, StateInterface } from "../../helper/interface";

const AddOrEditIndustry = ({
    errors,
    touched,
    handleChange,
    setFieldValue,
    values,
    handleBlur,
    setFieldTouched,
    dirty,
}: FormInterface<IndustryInterface>) => {
    const loading = useSelector((state: StateInterface) => state.base.loading);

    const positions = useFetch<PositionForSelect[]>(api.admin.getAllPositionForSelect);

    return (
        <Form>
            <div className="grid grid-cols-12 gap-4 gap-y-5 mt-5">
                <div className="intro-y col-span-12 sm:col-span-6">
                    <label htmlFor="name" className="form-label">
                        Industry
                    </label>
                    <input
                        id="name"
                        name="name"
                        type="text"
                        autoFocus
                        onChange={handleChange}
                        value={values.name}
                        onBlur={handleBlur}
                        className={`form-control ${errors.name && touched.name && "border-danger"}`}
                        placeholder="Education"
                    />
                    {errors.name && touched.name && <div className="text-danger">{errors.name}</div>}
                </div>
                <div className="intro-y col-span-12 sm:col-span-6">
                    <label className="mb-2 form-label">Positions</label>
                    <div className="">
                        {positions?.res?.data ? (
                            <Select
                                isMulti
                                name="positions"
                                options={positions?.res?.data}
                                value={values?.positions}
                                onBlur={() => setFieldTouched("positions", true)}
                                onChange={(selectedItem: MultiValue<PositionForSelect>) => {
                                    setFieldValue("positions", selectedItem);
                                }}
                                className={`form-control tom-select ${errors.positions && touched.positions && "border-danger"}`}
                                classNamePrefix="select"
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => String(option.positionId)}
                            />
                        ) : null}
                    </div>
                    {errors.positions && touched.positions && <div className="text-danger">{errors.positions}</div>}
                </div>
                <div className="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-5">
                    <button className="btn btn-secondary w-24" type="reset" disabled={!dirty}>
                        Reset
                    </button>
                    <button className="btn btn-primary w-24 ml-2" type="submit" disabled={loading || !dirty}>
                        Save
                    </button>
                </div>
            </div>
        </Form>
    );
};

export default AddOrEditIndustry;
